import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@tanstack/react-query';
import { CreateAdminRequest, } from '@wit-support/admin-contracts';
import { Button, Dialog, DialogContent, DialogDescription, DialogTitle, toast, } from '@wit-support/ui';
import { Actions, SubmitButton, ZodField, ZodForm } from '@wit-support/ui-forms';
import { createAdmin } from '../api.js';
export function CreateAdminDialog(props) {
    const { open, onOpenChange, onCreated } = props;
    const mut = useMutation({
        mutationFn: (body) => createAdmin(body),
        onSuccess: () => {
            toast.success('Admin invited');
            onCreated();
        },
        onError: (err) => toast.error(err.message),
    });
    return (_jsx(Dialog, { open: open, onOpenChange: onOpenChange, children: _jsxs(DialogContent, { children: [_jsx(DialogTitle, { children: "Invite admin" }), _jsx(DialogDescription, { children: "Creates an admin record and sets the initial login password. The invitee should change it on first sign-in." }), _jsxs(ZodForm, { schema: CreateAdminRequest, defaultValues: {
                        email: '',
                        displayName: '',
                        password: '',
                        role: 'member',
                        timezone: '',
                        telegramId: '',
                    }, onSubmit: (values) => {
                        const v = values;
                        const payload = {
                            email: v.email,
                            displayName: v.displayName,
                            password: v.password,
                            role: v.role,
                            ...(v.timezone ? { timezone: v.timezone } : {}),
                            ...(v.telegramId ? { telegramId: v.telegramId } : {}),
                        };
                        mut.mutate(payload);
                    }, children: [_jsx(ZodField, { name: "email" }), _jsx(ZodField, { name: "displayName" }), _jsx(ZodField, { name: "password" }), _jsx(ZodField, { name: "role" }), _jsx(ZodField, { name: "timezone" }), _jsx(ZodField, { name: "telegramId" }), _jsxs(Actions, { children: [_jsx(Button, { type: "button", variant: "ghost", onClick: () => onOpenChange(false), children: "Cancel" }), _jsx(SubmitButton, { pendingLabel: "Creating\u2026", children: "Create" })] })] })] }) }));
}
//# sourceMappingURL=create-dialog.js.map